package floris.graphics.landing.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import floris.graphics.core.navigation.Navigation
import com.materialdesignsystem.toColorScheme
import com.materialdesignsystem.constants.Constants
import floris.graphics.core.constants.Res
import floris.graphics.landing.components.widgets.Socials
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun LandingFooterSection(
    showMenu: Boolean,
    modifier: Modifier = Modifier
) {
    val colorScheme = ColorMode.current.toColorScheme
    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    val row = breakpoint >= Breakpoint.MD

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(topBottom = 48.px)
            .then(modifier),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Box(
                modifier = Modifier.fillMaxWidth(90.percent)
                    .display(DisplayStyle.Flex)
                    .flexDirection(if (row) FlexDirection.Row else FlexDirection.Column)
                    .flexWrap(FlexWrap.Wrap)
                    .alignItems(AlignItems.Center)
                    .rowGap(32.px)
                    .justifyContent(JustifyContent.SpaceBetween)
            ) {
                Image(
                    modifier = Modifier
                        .height(Constants.HEADER_COLLAPSED_LOGO_HEIGHT.px)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            ctx.router.navigateTo(Navigation.Screen.Home.route)
                        },
                    src = Res.Image.logo,
                    alt = "Logo Image"
                )

                if (showMenu) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth(90.percent)
                            .pointerEvents(PointerEvents.None) // Make sure this element does not prohibit any pointer events (or clicks)
                            .thenIf(row) {
                                Modifier.position(Position.Absolute)
                            },
                        horizontalArrangement = Arrangement.Center
                    ) {
                        NavigationItems(
                            modifier = Modifier.pointerEvents(PointerEvents.Auto),
                            row = true
                        )
                    }
                }

                Socials(Modifier)
            }

            Box(
                Modifier
                    .fillMaxWidth(90.percent)
                    .height(1.px)
                    .background(colorScheme.outlineVariant)
                    .margin(top = 20.px, bottom = 20.px)
            )

            SpanText(
                modifier = Modifier
                    .fontSize(14.px)
                    .textAlign(TextAlign.Center)
                    .color(colorScheme.onBackground.toRgb().copyf(alpha = 0.25f)),
                text = Res.String.Copyright
            )
            SpanText(
                modifier = Modifier
                    .margin(top = 6.px)
                    .textAlign(TextAlign.Center)
                    .fontSize(14.px)
                    .color(colorScheme.onBackground.toRgb().copyf(alpha = 0.25f)),
                text = Res.String.WebsiteCreatedBy
            )
        }
    }
}
